import Image from 'next/image';
import styled from 'styled-components';
import { DangerousInnerHTML } from '@/shared/components/dangerous-inner-html';
export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 100px;
`;
export const Step = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 365px;
  margin: 0 25px 30px;
  width: 100%;
  border-radius: 10px;
  background-color: #2b2f37;
  padding: 20px;
  min-height: 480px;

  @media screen and (min-width: 1441px) {
    max-width: 400px;
    margin: 0 30px;
    padding: 25px;
  }
`;
export const Number = styled.p`
  font-size: 36px;
  font-weight: 700;
  line-height: 40px;
  color: #fff;
  opacity: 0.5;
  margin-bottom: 15px;

  @media screen and (min-width: 1441px) {
    font-size: 38px;
    line-height: 44px;
  }
`;
export const Preview = styled(Image)`
  display: block;
  border-radius: 6px;
  box-shadow: 0 20px 40px -15px rgba(0, 0, 0, 0.5);
`;
export const Info = styled.div`
  margin-top: 25px;
  padding: 0 10px 0 5px;

  @media screen and (min-width: 1441px) {
    padding: 0 15px 0 10px;
  }
`;
export const Title = styled(DangerousInnerHTML)`
  margin: 0 0 10px;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  color: #fff;

  @media screen and (min-width: 1441px) {
    font-size: 26px;
    line-height: 34px;
  }
`;
export const Description = styled(DangerousInnerHTML)`
  & p {
    margin: 0 0 15px;
    font-size: 16px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.8);
    font-weight: 500;

    @media screen and (min-width: 1441px) {
      font-size: 18px;
      line-height: 24px;
      font-weight: 300;
    }
  }
`;